import React from 'react';
// eslint-disable-next-line import/no-anonymous-default-export
export default (props) => (
  <svg {...props} width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M15.2 0H0.8C0.4 0 0 0.4 0 0.8V11.2C0 11.6 0.4 12 0.8 12H15.2C15.7 12 16 11.6 16 11.2V0.8C16 0.4 15.6 0 15.2 0ZM13.1 1.5L8 5.4L3.1 1.5H13.1ZM1.5 10.5V2.1L8 7.3L14.5 2.3V10.5H1.5Z" fill="currentcolor" />
  </svg>
);
